import React from 'react';
import { FlyinNames } from '../../UIStateSlice';
import Legend from '../../tools/legend/Legend';
import IdentifyView from '../../tools/identify/IdentifyView';
import IdentifyLegend from '../../tools/identify/components/IdentifyLegend';
import Landowner from '../../tools/identify/components/Landowner';
import useAppState from '../../AppStore';

interface FlyinToolProps {
  key: string;
  label: string;
  isMainView: boolean;
  viewComponent: React.ReactNode;
  onClose?: () => void;
}

const useIndentifyFlyin = (): FlyinToolProps[] => {
  const setIdentifyCoordinate = useAppState((state) => state.setIdentifyCoordinate);
  const onClose = () => setIdentifyCoordinate(null);

  return [
    {
      key: 'identify',
      label: 'identify_flyin_label',
      viewComponent: <IdentifyView />,
      isMainView: true,
      onClose,
    },
    {
      key: 'identify_legende',
      label: 'legend',
      viewComponent: <IdentifyLegend />,
      isMainView: false,
      onClose,
    },
    {
      key: 'landowner',
      label: 'landowner_label',
      viewComponent: <Landowner />,
      isMainView: false,
      onClose,
    },
  ];
};

export const useFlyins = (): Record<FlyinNames, FlyinToolProps[]> => {
  return {
    [FlyinNames.Legends]: [
      {
        key: 'legend',
        label: 'legend',
        viewComponent: <Legend />,
        isMainView: true,
      },
    ],
    [FlyinNames.Identify]: useIndentifyFlyin(),
  };
};
